import React from "react";
import PropTypes from "prop-types";
import { AI_TOOL_NAMES } from "../../constants";

const AIFormTitle = ({ toolName }) => {
  switch (toolName) {
    case AI_TOOL_NAMES.ASK_AI:
      return <h1 className="title-5 tw-m-0">Ask LitCharts AI</h1>;
    case AI_TOOL_NAMES.DISCUSSION_QUESTIONS:
      return <h1 className="title-5 tw-m-0">Discussion Question Generator</h1>;
    case AI_TOOL_NAMES.QUIZ_QUESTIONS:
      return <h1 className="title-5 tw-m-0">Quiz Question Generator</h1>;
    case AI_TOOL_NAMES.ESSAY_PROMPTS:
      return <h1 className="title-5 tw-m-0">Essay Prompt Generator</h1>;
    default:
      return null;
  }
};

AIFormTitle.propTypes = {
  toolName: PropTypes.oneOf(Object.values(AI_TOOL_NAMES)).isRequired
};

export default AIFormTitle;
